module.exports = __webpack_public_path__ + "img/Mini_help green.6568cec1.png";